export default [
  {
    path: '/property-sales',
    name: 'PropertySalesList',
    component: () => import('pages/property-sales/PropertySalesList.vue')
  },
  {
    path: '/property-sales/:id',
    name: 'PropertySalesSingleLayout',
    redirect: { name: 'PropertySalesSingle' },
    component: () => import('pages/property-sales/single/_layouts/PropertySalesSingleLayout.vue'),
    children: [
      {
        path: '/property-sales/:id/summary',
        name: 'PropertySalesSingle',
        component: () => import('pages/property-sales/single/tabs/PropertySalesSingle.vue'),
        meta: { slug: 'sales-details' }
      },
      {
        path: '/property-sales/:id/documents',
        name: 'PropertySalesDocumentsList',
        component: () => import('pages/property-sales/single/tabs/PropertySalesDocumentsList.vue'),
        meta: { slug: 'documents' }
      },
      {
        path: '/property-sales/:id/history',
        name: 'PropertySalesHistoryList',
        component: () => import('pages/property-sales/single/tabs/PropertySalesHistoryList.vue'),
        meta: { slug: 'history' }
      }
    ]
  }
]
